<template>
  <div>
    <el-row style="margin-bottom: 24px;border-bottom: 1px solid #ddd;">
      <el-col :span="16" style="vertical-align: middle;">
        <h1>{{page_structure['name']}}</h1>
      </el-col>
      <el-col :span="8" style="text-align: right;vertical-align: middle;">
        <el-button icon="el-icon-circle-close-outline" @click="handle_offline_button_click">取消上線</el-button>
        <el-button icon="el-icon-download" @click="handle_export_button_click">匯出資料</el-button>
      </el-col>
    </el-row>
    <el-tabs v-model="active_tab_name" type="card">
      <el-tab-pane label="詮釋資料管理" name="metadata">
        <EditViewForm 
          :page_structure="page_structure"
          :preloaded_data="metadata"
          mode="view"
        />
      </el-tab-pane>
      <el-tab-pane label="數位物件管理" name="digital_object">
        <DetailPageDigitalObjectTab 
          :article_type="article_type"
          :article_id="article_id"
        />
      </el-tab-pane>
    </el-tabs>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import PageStructure from '@/views/backstage/structure/detail_page/DetailPageStructure'
import DetailPageDigitalObjectTab from '@/views/backstage/pages/DetailPageDigitalObjectTab'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'
import api from '@/api/index'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import articleExportMixin from '@/mixins/articleExportMixin'

export default {
    mixins: [
      breadcrumbMixin,
      articleExportMixin
    ],
    components: {
      LoadingBlock,
      DetailPageDigitalObjectTab,
      EditViewForm
    },
    data() {
      return {
        loading: false,//TODO: change this to true
        active_tab_name: 'metadata',
        page_structure: [],
        metadata: {}, 
        digital_object: {},
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/article',
        article_id: null,
        article_type: null
      }
    },
    created: function () {
        console.log('route type:', this.$route.params.type)
        console.log('route mode:', this.$route.params.mode)
        console.log('route id:', this.$route.params.id)

        if (!this.$route.params.type || !this.$route.params.id) {
          return 
        }

        this.page_structure = PageStructure(this.$route.params.type)
        console.log('page structure:', this.page_structure)    
        this.article_id = this.$route.params.id
        console.log('article id:', this.article_id)
        this.article_type = this.$route.params.type
        console.log('article type:', this.article_type)

        this.get_metadata()
    },
    methods: {
      async handle_offline_button_click () {
        console.log('offline button clicked')
        let res = await api.review_article(this.article_id, false)
        if (res['success'] !== true) {
          this.$message({
            type: 'error',
            message: `取消上線失敗. ${res['message']}.`
          }); 
        }
        this.backstage_router_push({ path: `/review-management/front-stage-data-publish` })
      },
      get_metadata () {

        this.loading = true
        
        axios.get(this.resource_api+'/get', {params: {system_id:this.article_id}})
            .then((response) => {
              this.loading = false
              console.log('reponse: ', response.data.payload)
              if (response.data.success) {
                this.$set(this, 'metadata', this.translate_to_display_data(this.page_structure, response.data.payload))
                this.update_breadcrumbs_title(this.metadata['title'])
              }
              else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', response.data.message)
              }
            })
            .catch(err => {
                this.loading = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
            })
      },
    }
  };
</script>

<style lang="scss" scoped>

.action_buttons {
  float: right;
  .el-button {
    margin-right: 22px;
  }
}

.choices-radio{
  margin-bottom: 22px;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.field {
  padding: 5px;
  background-color: rgba(25, 111, 61, 0.1);
  width: 200px;
  vertical-align: top;
  &+.value {
    vertical-align: top;
    padding: 5px;
  }
}
</style>
